import bag2 from '../../assets/img/bags/image_2.png';
import bag4 from '../../assets/img/bags/image_4.png';
import bag5 from '../../assets/img/bags/image_5.png';
import bag6 from '../../assets/img/bags/image_6.png';
import bag7 from '../../assets/img/bags/image_7.png';
import bag8 from '../../assets/img/bags/image_8.png';

export const listBagIconic = [
    {
        id: '1',
        img: bag2,
        title: 'Convertible Mini Merinal',
        cost: '$1,450.00',
        originalCost: '$2,000.00',
        des: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.',
        colors: ['#9BB4C0', '#000000', '#DA6666'],
        haveCustomize: true,
        details: {
            des: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using \'Content here, content here\', making it look like readable English.',
            measurements: 'Model is 178cm/ 5\'10" and is wearing a US 2',
            composition:  '92% POLYESTER 8% POLYURETHANE',
            washing_instructions: 'Dry clean only',
            made_in: 'Italy'
        },
        img_reviews: [bag2, bag8, bag2],
        reviews: [
            {
                name: 'John Bidenn',
                evaluate: 4,
                date: 'Oct 15, 2020',
                content: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s'
            },
            {
                name: 'Grant Marshall',
                evaluate: 3,
                date: 'Oct 15, 2020',
                content: 'When an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.'
            },
            {
                name: 'Pena Valdez',
                evaluate: 5,
                date: 'Oct 24, 2020',
                content: 'When an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries.'
            }
        ],
    },
    {
        id: '2',
        img: bag4,
        title: 'Letraset sheets containing Lorem Ipsum passages',
        cost: '$1,450.00',
        originalCost: '$2,000.00',
        des: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.',
        colors: ['#9BB4C0', '#000000', '#DA6666'],
        haveCustomize: true,
        details: {
            des: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using \'Content here, content here\', making it look like readable English.',
            measurements: 'Model is 178cm/ 5\'10" and is wearing a US 2',
            composition:  '92% POLYESTER 8% POLYURETHANE',
            washing_instructions: 'Dry clean only',
            made_in: 'Italy'
        },
        img_reviews: [bag2, bag8, bag2],
        reviews: [],
    },
    {
        id: '3',
        img: bag2,
        title: 'Hampden-Sydney College',
        cost: '$1,050.00',
        originalCost: '$2,000.00',
        des: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.',
        colors: ['#9BB4C0', '#000000', '#DA6666'],
        haveCustomize: true,
        details: {
            des: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using \'Content here, content here\', making it look like readable English.',
            measurements: 'Model is 178cm/ 5\'10" and is wearing a US 2',
            composition:  '92% POLYESTER 8% POLYURETHANE',
            washing_instructions: 'Dry clean only',
            made_in: 'Italy'
        },
        img_reviews: [bag2, bag8, bag2],
        reviews: [],
    },
    {
        id: '4',
        img: bag5,
        title: 'Convertible Mini Merinal',
        cost: '$950.00',
        originalCost: '$2,000.00',
        des: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.',
        colors: ['#9BB4C0', '#000000', '#DA6666'],
        haveCustomize: true,
        details: {
            des: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using \'Content here, content here\', making it look like readable English.',
            measurements: 'Model is 178cm/ 5\'10" and is wearing a US 2',
            composition:  '92% POLYESTER 8% POLYURETHANE',
            washing_instructions: 'Dry clean only',
            made_in: 'Italy'
        },
        img_reviews: [bag2, bag8, bag2],
        reviews: [],
    },
    {
        id: '5',
        img: bag6,
        title: 'Convertible Mini Merinal',
        cost: '$1,450.00',
        originalCost: '$2,000.00',
        des: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.',
        colors: ['#9BB4C0', '#000000', '#DA6666'],
        haveCustomize: true,
        details: {
            des: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using \'Content here, content here\', making it look like readable English.',
            measurements: 'Model is 178cm/ 5\'10" and is wearing a US 2',
            composition:  '92% POLYESTER 8% POLYURETHANE',
            washing_instructions: 'Dry clean only',
            made_in: 'Italy'
        },
        img_reviews: [bag2, bag8, bag2],
        reviews: [],
    },
    {
        id: '6',
        img: bag7,
        title: 'Letraset sheets containing Lorem Ipsum passages',
        cost: '$1,450.00',
        originalCost: '$2,000.00',
        des: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.',
        colors: ['#9BB4C0', '#000000', '#DA6666'],
        haveCustomize: true,
        details: {
            des: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using \'Content here, content here\', making it look like readable English.',
            measurements: 'Model is 178cm/ 5\'10" and is wearing a US 2',
            composition:  '92% POLYESTER 8% POLYURETHANE',
            washing_instructions: 'Dry clean only',
            made_in: 'Italy'
        },
        img_reviews: [bag2, bag8, bag2],
        reviews: [],
    },
    {
        id: '7',
        img: bag8,
        title: 'Convertible Mini Merinal',
        cost: '$950.00',
        originalCost: '$2,000.00',
        des: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.',
        colors: ['#9BB4C0', '#000000', '#DA6666'],
        haveCustomize: true,
        details: {
            des: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using \'Content here, content here\', making it look like readable English.',
            measurements: 'Model is 178cm/ 5\'10" and is wearing a US 2',
            composition:  '92% POLYESTER 8% POLYURETHANE',
            washing_instructions: 'Dry clean only',
            made_in: 'Italy'
        },
        img_reviews: [bag2, bag8, bag2],
        reviews: [],
    },
    {
        id: '8',
        img: bag2,
        title: 'Convertible Mini Merinal',
        cost: '$1,450.00',
        originalCost: '$2,000.00',
        des: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.',
        colors: ['#9BB4C0', '#000000', '#DA6666'],
        haveCustomize: true,
        details: {
            des: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using \'Content here, content here\', making it look like readable English.',
            measurements: 'Model is 178cm/ 5\'10" and is wearing a US 2',
            composition:  '92% POLYESTER 8% POLYURETHANE',
            washing_instructions: 'Dry clean only',
            made_in: 'Italy'
        },
        img_reviews: [bag2, bag8, bag2],
        reviews: [],
    },
    {
        id: '9',
        img: bag4,
        title: 'Letraset sheets containing Lorem Ipsum passages',
        cost: '$1,450.00',
        originalCost: '$2,000.00',
        des: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.',
        colors: ['#9BB4C0', '#000000', '#DA6666'],
        haveCustomize: true,
        details: {
            des: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using \'Content here, content here\', making it look like readable English.',
            measurements: 'Model is 178cm/ 5\'10" and is wearing a US 2',
            composition:  '92% POLYESTER 8% POLYURETHANE',
            washing_instructions: 'Dry clean only',
            made_in: 'Italy'
        },
        img_reviews: [bag2, bag8, bag2],
        reviews: [],
    },
    {
        id: '10',
        img: bag2,
        title: 'Hampden-Sydney College',
        cost: '$1,050.00',
        originalCost: '$2,000.00',
        des: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.',
        colors: ['#9BB4C0', '#000000', '#DA6666'],
        haveCustomize: true,
        details: {
            des: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using \'Content here, content here\', making it look like readable English.',
            measurements: 'Model is 178cm/ 5\'10" and is wearing a US 2',
            composition:  '92% POLYESTER 8% POLYURETHANE',
            washing_instructions: 'Dry clean only',
            made_in: 'Italy'
        },
        img_reviews: [bag2, bag8, bag2],
        reviews: [],
    },
    {
        id: '11',
        img: bag5,
        title: 'Convertible Mini Merinal',
        cost: '$950.00',
        originalCost: '$2,000.00',
        des: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.',
        colors: ['#9BB4C0', '#000000', '#DA6666'],
        haveCustomize: true,
        details: {
            des: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using \'Content here, content here\', making it look like readable English.',
            measurements: 'Model is 178cm/ 5\'10" and is wearing a US 2',
            composition:  '92% POLYESTER 8% POLYURETHANE',
            washing_instructions: 'Dry clean only',
            made_in: 'Italy'
        },
        img_reviews: [bag2, bag8, bag2],
        reviews: [],
    },
];
